export default __webpack_public_path__ + "static/media/usePotion.0aee7868.mp3";